<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    {{ modalTitle() }}
  </div>

  <div
    [formGroup]="newContentValueForm"
    (submitForm)="submitModal()"
    class="flx-modal-body"
    flxEnterSubmitForm
  >
    <div class="flex flex-row gap-4 w-full">
      <flx-input class="w-full flx-ds">
        <flx-label class="flx-ds mandatory">{{ keyTitle }}</flx-label>
        <input
          [placeholder]="placeholder()"
          flxAutofocus
          flxInput
          formControlName="code"
          data-testId="substitution-key-input"
        />
        @if (codeFC.touched && codeFC.errors?.required) {
          <flx-error class="flx-ds">{{ keyError }}</flx-error>
        } @else if (codeFC.errors?.pattern) {
          <flx-error
            class="flx-ds"
            data-testId="invalid-key-error"
            >You can only use letters, numbers and characters [] () . _ -</flx-error
          >
        } @else if (codeFC.errors?.reservedSystemPrefix) {
          <flx-error
            class="flx-ds"
            data-testId="reserved-prefix-error"
            >{{ reservedPrefixError }}</flx-error
          >
        }
      </flx-input>

      @if (isEnumeration) {
        <flx-input class="flx-ds w-[80px]">
          <flx-label class="flx-ds">Order</flx-label>
          <input
            placeholder="Order"
            flxInput
            type="number"
            min="0"
            formControlName="order"
            data-testId="content-order-input"
          />
          @if (orderFC.touched && orderFC.errors?.required) {
            <flx-error class="flx-ds">Required</flx-error>
          } @else if (orderFC.errors?.min) {
            <flx-error class="flx-ds">Min is 0</flx-error>
          }
        </flx-input>
      }
    </div>

    <div class="flex flex-col p-4 gap-4 w-full bg-neutral-50 dark:bg-neutral-800 rounded-lg">
      <div
        class="flex flex-row mt-4 w-full justify-center items-center gap-4 text-sm font-semibold"
      >
        Languages
      </div>
      <ng-container [formGroup]="contentMap">
        @for (language of languages; track language) {
          <flx-input class="flx-ds">
            <flx-label class="flx-ds font-semibold">{{ language.code }}</flx-label>
            <input
              [formControlName]="language.code"
              [placeholder]="language.name"
              [attr.data-testId]="'input-field-' + language.code"
              flxInput
            />
          </flx-input>
        }
      </ng-container>
      @if (isEnumeration && sourceSystemsValues.length > 0) {
        <div
          class="flex flex-row mt-4 w-full justify-center items-center gap-4 text-sm font-semibold"
        >
          Source Systems
        </div>
        <ng-container [formGroup]="sourceSystems">
          @for (sourceSystem of sourceSystemsValues; track sourceSystem) {
            <flx-input class="flx-ds">
              <flx-label class="flx-ds font-semibold">{{ sourceSystem.code }}</flx-label>
              <input
                [formControlName]="sourceSystem.code"
                [placeholder]="sourceSystem.name"
                flxInput
              />
            </flx-input>
          }
        </ng-container>
      }
    </div>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        data-testId="cancel-button"
        flxButton
        type="button"
        variant="ghost"
      >
        Cancel
      </button>
      <button
        [disabled]="readOnly || newContentValueForm.invalid"
        (click)="submitModal()"
        class="flx-ds primary"
        data-testId="save-item-button"
        flxButton
        type="button"
      >
        {{ submitButtonTitle }}
      </button>
    </div>
  </div>
</flx-modal>
